// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2nowh","title":"Images45_title__2nkje","images":"Images45_images__1RmbF"};